var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title" }, [
      _vm._v(" " + _vm._s(_vm.$t("data.payout_transaction")) + " "),
    ]),
    _c("div", { staticClass: "page-container" }, [_c("PayoutTransDetails")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }